// extracted by mini-css-extract-plugin
export default {"metric-value":"metric-value-LlHW2","metric-budget":"metric-budget-nLWsC"};